<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>{{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}</i>
                    </dt>
                    <dd>
                        <div class="view_cont" v-for="(item, idx) in faqList" :key="pageName + item.FAQ_ID + idx">
                            <dl class="view_subject">
                                <dt class="subject qna_view">
                                    <em class="textcolor_urgent" v-if="'S' === item.GRADE">
                                        [{{ $t('FIELD.GLOBAL.IMPORTANT') }}]
                                    </em>
                                    {{ item.TITLE }}
                                    <span class="in_date">{{ item.REG_DT }}</span>
                                </dt>
                            </dl>

                            <div class="view_question">
                                <!-- faq_wrap -->
                                <div class="faq_wrap">
                                    <div class="ico_faq_a">
                                        <div class="q_cont" v-html="stripHtml(item.QUESTION_DESC)"></div>
                                        <div class="a_cont">
                                            <span v-html="stripHtml(item.SOLUTION_DESC)"></span>
                                            <span v-if="0 < item.ATTCH_CNT">
                                                <br />
                                                <a
                                                    :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    download="true"
                                                    target="_blank"
                                                    class="txt_link"
                                                    v-for="file in attach"
                                                    :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                                >
                                                    {{ file.FILE_NM }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'viewFAQ',
    props: {
        searchKey: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'viewFAQ',
            pageTitle: '',
            faqList: [],
            attach: [],
            serviceType: 'common',
        };
    },
    mounted() {
        this.searchList();
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            loginSystem: 'getLoginSystem',
        }),
    },
    watch: {
        supportSnb() {
            this.initializeSearch(false);
        },
    },
    methods: {
        async searchList() {
            let url = `${SDLUtil.API_URL}/basis/faq/faqSearch.skp`;
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    url,
                    qs.stringify({
                        page: 1,
                        systemId: this.loginSystem,
                        faqId: this.searchKey,
                    }),
                )
                .then(resp => {
                    this.faqList = resp.data.list.rowData;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/viewFaqPopup.vue